import { WTextfield } from '@alice-health/wonderland-react'
import { FunctionComponent } from 'react'
import { useFormContext } from 'react-hook-form'

const CompanyCNPJField: FunctionComponent = () => {
  const {
    register,
    setValue,
    clearErrors,
    trigger,
    formState: { errors }
  } = useFormContext<{
    cnpj: string
  }>()

  return (
    <>
      <WTextfield
        {...register('cnpj')}
        placeholder='CNPJ da empresa'
        maskType='cnpj'
        invalid={!!errors.cnpj}
        errorText={errors.cnpj?.message}
        onWChange={ev => setValue('cnpj', ev.detail)}
        onInput={() => clearErrors('cnpj')}
        onBlur={() => trigger('cnpj')}
      />
    </>
  )
}

export { CompanyCNPJField }
